import { FC } from 'react';
import SearchBarBox from 'Modules/Shared/components/SearchInput/SearchBarBox';
import { ACTIONS_SEARCH_PLACEHOLDER } from 'Modules/ActionsRewrite/components/constants';

const LoaderSearchInput: FC = () => {
  return (
    <div className="min-w-[40%]">
      <SearchBarBox width={360} placeholder={ACTIONS_SEARCH_PLACEHOLDER} />
    </div>
  );
};

export default LoaderSearchInput;
